module.exports = __webpack_public_path__ + "static/media/csharp.ca66e964.svg";